import React from 'react';
import TeamFeature from '../features/team/Team';

const TeamPage: React.FC = () => {
    return <TeamFeature />;
};

export default TeamPage;
